import { render, staticRenderFns } from "./AddressListing.vue?vue&type=template&id=20cc8ba9&scoped=true"
import script from "./AddressListing.vue?vue&type=script&lang=js"
export * from "./AddressListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cc8ba9",
  null
  
)

export default component.exports